import React from 'react';
import { PageHero, CtaRow } from '../PublicLayout';
import { HOME_FEATURES, SPORT_TAGS } from '../content';

const EXTRA = [
  { icon: '07', title: 'Live game feed', body: 'Scores and matchups update automatically so you can challenge around what is happening now.' },
  { icon: '08', title: 'Challenge tickets', body: 'Send a ticket link by text. Your friend opens it and joins your challenge directly — no account hunting.' },
  { icon: '09', title: 'Open arena', body: 'Post an open challenge and let another player accept it, or keep it private with friends.' },
];

export default function FeaturesPage() {
  return (
    <>
      <PageHero
        eyebrow="Platform"
        title="Built for real competition"
        subtitle="Everything inside The Lockbox is designed to make head-to-head challenges simple, fair, and transparent."
      />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...HOME_FEATURES, ...EXTRA].map((f) => (
            <article key={f.title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:border-emerald-500/30 transition-colors">
              <span className="text-[11px] font-black uppercase tracking-[0.28em] text-emerald-400 mb-4 block" aria-hidden>{f.icon}</span>
              <h3 className="text-lg font-black tracking-tight text-white mb-2">{f.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{f.body}</p>
            </article>
          ))}
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10 text-center">
        <p className="text-[10px] font-black uppercase tracking-[0.3em] text-emerald-400 mb-4">Sports covered</p>
        <div className="flex flex-wrap justify-center gap-2.5">
          {SPORT_TAGS.map((s) => (
            <span key={s} className="px-4 py-2 rounded-full bg-white/[0.05] text-[10px] font-black uppercase tracking-widest text-gray-400">
              {s}
            </span>
          ))}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-center">
        <CtaRow />
      </section>
    </>
  );
}
